
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Episode, Movie, TvShow } from "@/services/apiService/api.types";
import { Action, Getter, Mutation } from "vuex-class";
import { Namespace } from "@/store/types";
import DateTimeSection from "@/components/DateTimeSection.vue";
import SpatialNavigation from "spatial-navigation-js";
import {
  VodPageAction,
  VodPageGetter,
  VodPageMutation,
  VoDType
} from "@/components/VoD/types";
import PlayerBase from "@/components/player/components/PlayerBase.vue";
import { isTvShow } from "@/helpers/utils";
import { OverlayMutation } from "@/components/overlay/types";

@Component({
  components: {
    PlayerBase,
    DateTimeSection
  }
})
export default class EpisodeInfoModal extends Vue {
  @Prop() readonly tvShow!: TvShow;
  @Prop() readonly isVodItemInPackage!: boolean;

  @Action(VodPageAction.UpdateClosePlayer, {
    namespace: Namespace.Vod
  })
  updateClosePlayer!: (status: boolean) => void;

  @Mutation(OverlayMutation.SetActiveVodItem, {
    namespace: Namespace.Overlay
  })
  setActiveVodItem!: (vod: Movie | Episode | null) => void;

  @Mutation(VodPageMutation.setShowEpisodeInfoModal, {
    namespace: Namespace.Vod
  })
  setShowEpisodeInfoModal!: (show: boolean) => void;

  @Getter(VodPageGetter.GetViewedVodType, {
    namespace: Namespace.Vod
  })
  getViewedVodType?: VoDType;

  @Getter(VodPageGetter.GetInfoModalVodId, {
    namespace: Namespace.Vod
  })
  getInfoModalVodId!: number;

  @Getter(VodPageGetter.GetClosePlayer, { namespace: Namespace.Vod })
  getClosePlayer!: boolean;

  @Getter(VodPageGetter.GetActiveEpisode, { namespace: Namespace.Vod })
  getActiveEpisode!: Episode | null;

  isFavorite = false;

  async mounted(): Promise<void> {
    SpatialNavigation.resume();
    SpatialNavigation.focus("#backBtnEpisodeModal");
  }

  get activeVoDSplash(): string {
    return this.getActiveEpisode?.media
      ? this.getActiveEpisode.media.url
      : this.imgPlaceholder;
  }

  get imgPlaceholder(): string {
    return require("/src/assets/images/square-image-placeholder.jpg");
  }

  get vodTitle(): string {
    return this.getActiveEpisode ? this.getActiveEpisode.name : "";
  }

  get vodDescription(): string {
    return this.getActiveEpisode !== null &&
      this.getActiveEpisode.description !== undefined &&
      this.getActiveEpisode.description !== ""
      ? this.getActiveEpisode.description
      : "Unknown";
  }

  get vodDirector(): string {
    if (
      this.getActiveEpisode !== null &&
      this.getActiveEpisode.director !== undefined &&
      this.getActiveEpisode.director !== ""
    ) {
      return this.getActiveEpisode.director;
    }

    return "Unknown";
  }

  get vodCast(): string {
    if (
      this.getActiveEpisode !== null &&
      this.getActiveEpisode.cast !== undefined &&
      this.getActiveEpisode.cast !== ""
    ) {
      return this.getActiveEpisode.cast;
    }

    return "Unknown";
  }

  get seasonAndEpisodeNum(): string {
    for (let i = 0; i < this.tvShow.seasons!.length; i++) {
      for (let j = 0; j < this.tvShow.seasons![i].episodes.length; j++) {
        if (
          this.getActiveEpisode &&
          this.tvShow.seasons![i].episodes[j].id === this.getActiveEpisode.id
        ) {
          return (
            this.tvShow.seasons![i].name +
            " / " +
            this.tvShow.seasons![i].episodes[j].name
          );
        }
      }
    }

    return "";
  }

  closeOverlay(): void {
    if (this.getClosePlayer) return this.updateClosePlayer(false);
    if (!this.getClosePlayer) {
      this.setShowEpisodeInfoModal(false);
    }
  }

  handlePlay(): void {
    //only Movie or TV Show Episode will have a play button enabled since a Tv Show must select an episode to view
    this.setActiveVodItem(this.getActiveEpisode as Episode);
    this.updateClosePlayer(true);
  }

  @Watch("getClosePlayer")
  handleChannelUpdate(newVal: boolean): void {
    if (!newVal && !isTvShow(this.getActiveEpisode)) {
      SpatialNavigation.focus("#episodePlayBtn");
    }
  }
}
